<template>
    <section class="section section-lg">
        <div class="container">
            <div class="row row-grid align-items-center">
                <div class="col-md-6 order-md-2">
                    <img src="img/theme/promo-1.png" class="img-fluid floating">
                </div>
                <div class="col-md-6 order-md-1">
                    <div class="pr-md-5">
                        <icon name="ni ni-world" class="mb-5" size="lg" type="success" shadow
                                rounded></icon>
                        <h3>DevOps</h3>
                        <p>The kit comes with three pre-built pages to help you get started faster. You can change
                            the text and images and you're good to go.</p>
                        <ul class="list-unstyled mt-5">
                            <li class="py-2">
                                <div class="d-flex align-items-center">
                                    <badge type="success" circle class="mr-3" icon="ni ni-settings-gear-65"></badge>
                                    <h6 class="mb-0">Docker, Kubernetes
                                    </h6>
                                </div>
                            </li>
                            <li class="py-2">
                                <div class="d-flex align-items-center">
                                    <badge type="success" circle class="mr-3" icon="ni ni-html5"></badge>
                                    <h6 class="mb-0">Gitlab CI, Github Actions, Jenkins</h6>
                                </div>
                            </li>
                            <li class="py-2">
                                <div class="d-flex align-items-center">
                                    <badge type="success" circle class="mr-3" icon="ni ni-archive-2"></badge>
                                    <h6 class="mb-0">Gradle, Maven, Ant</h6>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
}
</script>

<style>

</style>